import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import "./NewFooter.css";
import { s3_url } from "common/constants";

const NewFooter: React.FC = () => {
  return (
    <footer className="lumen-footer">
      <div className="lumen-footer-top">
        <Container>
          <Row className="align-items-start gy-4">
            <Col md={4}>
              <h5>Poveznice</h5>
              <ul className="footer-links">
                <li>
                  <Link to="/izjava-privatnosti">Izjava o privatnosti</Link>
                </li>
                <li>
                  <Link to="/politika-privatnosti">Politika privatnosti</Link>
                </li>
                <li>
                  <Link to="/cookie-policy">Politika kolačića</Link>
                </li>
                <li>
                  <Link to="/opci-uvjeti">Opći uvjeti</Link>
                </li>
                <li>
                  <Link to="/sigurnost-placanja">
                    Sigurnost plaćanja kreditnim karticama
                  </Link>
                </li>
              </ul>
            </Col>

            <Col md={4} className="text-md-center">
              <h5>Društvene mreže</h5>
              <div className="socials">
                <a
                  href="https://www.facebook.com/lumenpoduke1"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebook />
                </a>
                <a
                  href="https://www.instagram.com/lumenpoduke/"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
              </div>
            </Col>

            <Col md={4}>
              <h5>Kontakt</h5>
              <address className="mb-0">
                <strong>Obrt za poduke "Lumen" vl. Karmen Dasović</strong>
                <br />
                upisan u Obrtni registar Republike Hrvatske
                <br />
                <strong>OIB:</strong> 02593652259
                <br />
                Porezni broj (PDV ID): HR02593652259
                <br />
                <strong>Matični broj:</strong> 90285697
                <br />
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:info@lumenpoduke.com"
                  style={{ textDecoration: "none" }}
                >
                  info@lumenpoduke.com
                </a>
                <br />
                <strong>Telefon:</strong>{" "}
                <a
                  href="tel:+385 098 257 119"
                  style={{ textDecoration: "none" }}
                >
                  +385 098 257 119
                </a>
                <br />
                <strong>Adresa:</strong> Ul. Fiorella La Guardia 12, 51000,
                Rijeka, Hrvatska
              </address>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="lumen-footer-payments">
        <Container className="d-flex justify-content-center flex-wrap gap-3">
          <a href="https://www.mastercard.com" target="_blank" rel="noreferrer">
            <img
              src={`${s3_url}/img/footer/mc_vrt_opt_pos_73_3x.png`}
              alt="Mastercard"
              height={40}
            />
          </a>
          <a
            href="https://brand.mastercard.com/brandcenter/more-about-our-brands.html"
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={`${s3_url}/img/footer/ms_vrt_opt_pos_73_3x.png`}
              alt="Maestro"
              height={40}
            />
          </a>
          <a
            href={`https://www.visaeurope.com`}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={`${s3_url}/img/footer/Visa 2015 50.gif`}
              alt="Visa"
              height={40}
            />
          </a>
          <img
            src={`${s3_url}/img/footer/visa-secure-blk_300dpi.jpg`}
            alt="Visa secure"
            height={40}
          />
          <img
            src={`${s3_url}/img/footer/mc_idcheck_hrz_rgb_pos.png`}
            alt="MC ID Check"
            height={40}
          />
          <a href="https://www.monri.com" target="_blank" rel="noreferrer">
            <img
              src={`${s3_url}/img/footer/monri_footer.png`}
              alt="Monri"
              height={40}
            />
          </a>
        </Container>
      </div>
    </footer>
  );
};

export default NewFooter;
